import { PREDEFINED_SHIPPING_METHODS } from '../../shipping/constants';

export function parseCustomShippingMethods(fields: string[]): any[] {
  const methods = [];
  
  // Process 10 sets of shipping method fields (5 fields per method)
  for (let i = 0; i < 50; i += 5) {
    const name = fields[i];
    if (!name) continue;

    // Find predefined method or create custom
    const predefinedMethod = PREDEFINED_SHIPPING_METHODS.find(m => m.label === name);
    const method = {
      name: predefinedMethod?.value || 'other',
      carrierName: predefinedMethod ? undefined : name,
      price: fields[i + 1],
      hokkaido: fields[i + 2],
      okinawa: fields[i + 3],
      island: fields[i + 4]
    };

    if (method.name || method.carrierName) {
      methods.push(method);
    }
  }

  return methods;
}